export const MAX_USER_DETAILS_WIDTH = 1120
export const DEFAULT_CURRENCY = "USD"
export const CARD_ISSUANCE_FEE = 2
export const CARD_ISSUANCE_FEE_MESSAGE = `This will issue a real card and charge a $${CARD_ISSUANCE_FEE} issuance fee to the company balance.`
